import type { API } from '../../aiStreamingOrchestratorPluginType';

/**
 * Returns the node type names of the ancestors of the current selection head, ordered
 * outermost (document root) to innermost.
 *
 * Streaming commands set the selection to the position the streamed content is destined
 * for, so reading the selection straight after a command is applied yields that
 * destination's ancestry. Downstream consumers use it to reason about the real parent of
 * content that is otherwise parsed in isolation.
 *
 * Returns `undefined` when there is no editor API or the selection cannot be read.
 */
export function getParentNodeTypes(api: API | undefined): string[] | undefined {
	let parentNodes: string[] | undefined;
	// Read-only peek at the current transaction, matching `getPmDoc`.
	api?.core.actions.execute(({ tr }) => {
		const { $from } = tr.selection;
		const types: string[] = [];
		for (let depth = 0; depth <= $from.depth; depth++) {
			types.push($from.node(depth).type.name);
		}
		parentNodes = types;
		return null;
	});
	return parentNodes;
}
